import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-related-image-stack.component.scss';
import * as $ from 'jquery';
var ImageRelatedImageStack = /** @class */ (function (_super) {
    tslib_1.__extends(ImageRelatedImageStack, _super);
    function ImageRelatedImageStack(element) {
        return _super.call(this, element) || this;
    }
    ImageRelatedImageStack.prototype.init = function () {
        this.containers = Array.from(this.element.querySelectorAll('.image-related-image-stack-item__type-feature'));
        this.buttons = Array.from(this.element.querySelectorAll('.image-related-image-stack-item'));
    };
    ImageRelatedImageStack.prototype.bindEvents = function () {
        var _this = this;
        this.buttons.map(function (item) { return item.addEventListener('click', function (event) {
            var element;
            var clickedTarget = event.target;
            element = clickedTarget.closest('.image-related-image-stack-item');
            var clickedIndex = element.getAttribute('data-index');
            _this.hideActiveButtons();
            element.classList.add('active');
            _this.hideContainers();
            _this.containers.map(function (item) {
                if (item.getAttribute('data-index') === clickedIndex) {
                    item.classList.remove('d-none');
                    if (document.querySelector('.header')) {
                        if (document.querySelector('.header').classList.contains('header--sticky')) {
                            $('html,body').animate({
                                scrollTop: $(_this.element).offset().top - 65
                            }, 'slow');
                        }
                        else {
                            $('html,body').animate({
                                scrollTop: $(_this.element).offset().top - 195
                            }, 'slow');
                        }
                    }
                }
            });
        }); });
    };
    ImageRelatedImageStack.prototype.hideActiveButtons = function () {
        this.buttons.map(function (item) {
            item.classList.remove('active');
        });
    };
    ImageRelatedImageStack.prototype.hideContainers = function () {
        this.containers.map(function (item) {
            item.classList.add('d-none');
        });
    };
    return ImageRelatedImageStack;
}(Base));
export { ImageRelatedImageStack };



//////////////////
// WEBPACK FOOTER
// ./components/image-related-image-stack/image-related-image-stack.component.ts
// module id = 372
// module chunks = 0